<mat-card class="cardWithShadow">
	<mat-card-content class="p-5">
		<div class="row d-flex">
			<div class="col-md-4 d-flex">
				<mat-form-field appearance="outline" class="w-200 hide-hint">
					<mat-label>Buscar</mat-label>
					<input
					matInput
					[(ngModel)]="filterValue"
					toUppercase
					(keyup)="applyFilter()"
					/>
					<mat-icon matPrefix class="op-5">search</mat-icon>
				</mat-form-field>
			</div>
			<div class="col-md-2 d-flex">
				<mat-form-field appearance="outline" class="w-100 hide-hint">
					<mat-label>Filtro columna</mat-label>
					<mat-select  id="selectedColumn" name="selectedColumn" [(ngModel)]="selectedColumn" (selectionChange)="applyFilter()">
						<mat-option value="todas" >TODAS</mat-option>
						<mat-option *ngFor="let filtro of filtros" value="{{filtro.value}}">
							{{filtro.text}}
						</mat-option>
					</mat-select>
					<mat-icon matPrefix class="op-5">filter_list</mat-icon>
				</mat-form-field>
			</div>
					
			<div class="col-md-2 d-flex"></div>

			<div class="col-md-2 d-flex">
				<button mat-flat-button (click)="exportToExcel()" color="primary" class="w-100">
					Exportar
					<mat-icon>import_export</mat-icon>
				</button>
			</div>
			<div class="col-md-2 d-flex">
				<button mat-flat-button (click)="openDialog(null)" color="accent" class="w-100">
				<mat-icon>library_add</mat-icon>
				Agregar
				</button>
      		</div>
			
		</div>
		
	</mat-card-content>
</mat-card>
<mat-card class="cardWithShadow">
	<mat-card-content class="p-5">
		<div class="table-responsive">
			<table mat-table [dataSource]="dataPerfiles" cdkDropList class="mat-elevation-z8" [cdkDropListData]="perfiles" (cdkDropListDropped)="dropTable($event)">

				<ng-container matColumnDef="ordenJerarquia">
					<th mat-header-cell *matHeaderCellDef style="text-align: center;" >Jerarquía<mat-icon class="m-r-10 cursor-pointer" color="accent" (click)="guardarJerarquia()" #tooltip="matTooltip"
						matTooltip= "Guardar Jerarquía"
						matTooltipPosition="above" style="vertical-align: middle;">save</mat-icon></th>
					<td mat-cell *matCellDef="let element" style="text-align: center;">
					<mat-icon *ngIf="element.ordenJerarquia > 2" class="dragCursor" style="pointer-events: all;" cdkDragHandle>reorder</mat-icon>
					</td>
				</ng-container>

				<ng-container matColumnDef="nombrePerfil">
					<th mat-header-cell *matHeaderCellDef style="text-align: center;" class="f-s-11" >Perfil</th>
					<td mat-cell *matCellDef="let element" style="text-align: center;" class="f-s-11">{{ element.nombrePerfil }}</td>
				</ng-container> 

				<ng-container matColumnDef="usarDatosNacionales">
					<th mat-header-cell *matHeaderCellDef style="text-align: center;" class="f-s-11" >Usar Datos Nacionales</th>
					<td mat-cell *matCellDef="let element" style="text-align: center;" class="f-s-11">{{ element.usarDatosNacionales? 'SI' : 'NO' }}</td>
				</ng-container> 

				<ng-container matColumnDef="action">
					<th mat-header-cell *matHeaderCellDef style="text-align: center;" class="f-s-11">Acciones</th>
					<td mat-cell *matCellDef="let element" style="text-align: center;" class="action-link">
						
							<mat-icon
							*ngIf="element.ordenJerarquia > 2"
							#tooltip="matTooltip"
							matTooltip= "Editar"
							matTooltipPosition="above"
							(click)="openDialog(element)" 
							color="primary" 
							matPrefix 
							class="m-r-10 cursor-pointer">edit</mat-icon>
							<mat-icon
							*ngIf="element.ordenJerarquia > 2"
							#tooltip="matTooltip"
							matTooltip= "Eliminar"
							matTooltipPosition="above"
							(click)="deletePerfil(element)" 
							color="accent" 
							matPrefix 
							class="m-r-10 cursor-pointer">delete</mat-icon>
						
					</td>
				</ng-container>
				
				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag [cdkDragData]="row" [cdkDragDisabled]="row.ordenJerarquia <= 2" ></tr>
			</table>
		</div>
	</mat-card-content>
</mat-card>